import { Link, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { Calendar, ArrowLeft } from 'lucide-react'
import { usePublicArticle } from '../hooks/useApi'
import { Button } from '../components/ui/Button'

export default function ArticleDetail() {
  const { slug } = useParams()
  const { data: article, isLoading, error } = usePublicArticle(slug)

  useEffect(() => {
    if (article?.title) {
      document.title = `${article.title} | UMKM Indonesia`
      const meta = document.querySelector('meta[name="description"]')
      if (meta && article.metaDescription) {
        meta.setAttribute('content', article.metaDescription)
      }
    }
    return () => {
      document.title = 'UMKM Indonesia'
    }
  }, [article])

  if (isLoading) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-16 animate-pulse space-y-4">
        <div className="h-8 bg-gray-200 rounded w-3/4" />
        <div className="h-4 bg-gray-100 rounded w-1/4" />
        <div className="h-40 bg-gray-100 rounded" />
      </div>
    )
  }

  if (error || !article) {
    return (
      <div className="max-w-3xl mx-auto px-4 py-16 text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Artikel tidak ditemukan</h1>
        <Link to="/artikel">
          <Button variant="outline">Kembali ke daftar artikel</Button>
        </Link>
      </div>
    )
  }

  const dateStr = new Date(article.publishedAt || article.createdAt).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <Link
        to="/artikel"
        className="inline-flex items-center gap-2 text-sm text-indigo-600 hover:text-indigo-800 mb-8"
      >
        <ArrowLeft className="h-4 w-4" />
        Semua artikel
      </Link>

      <header className="mb-8">
        <p className="text-sm text-indigo-600 font-medium mb-2">Artikel UMKM Indonesia</p>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight">{article.title}</h1>
        <p className="mt-4 text-gray-500 flex items-center gap-2 text-sm">
          <Calendar className="h-4 w-4" />
          {dateStr}
        </p>
        {article.excerpt && (
          <p className="mt-4 text-lg text-gray-600 border-l-4 border-indigo-500 pl-4">{article.excerpt}</p>
        )}
      </header>

      <div className="prose prose-lg max-w-none text-gray-700 whitespace-pre-wrap leading-relaxed">
        {article.content}
      </div>

      <div className="mt-12 pt-8 border-t border-gray-200">
        <p className="text-gray-600 mb-4">Siap membuat katalog produk untuk UMKM Anda?</p>
        <Link to="/register">
          <Button>Daftar Gratis Sekarang</Button>
        </Link>
      </div>
    </article>
  )
}
